import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Chip,
  Box,
  CircularProgress,
  Alert
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useGetAdminStaffDetailsQuery } from "src/reduxServer/services/adminStaff";
import { useTranslation } from "react-i18next";
import NoDataFound from "src/components/NoDataFound";


const StaffDetailsCard = () => {
  const { id } = useParams();
  const {t} = useTranslation()

  const { data, isLoading, error } =
    useGetAdminStaffDetailsQuery(id!, {
      skip: !id,
    });
    console.log("data fetch>>>",data)
    const detailsData = data?.data

  /* ---------- LOADING ---------- */
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" mt={5}>
        <CircularProgress />
      </Box>
    );
  }

  /* ---------- ERROR ---------- */


  if (!data){
    return <NoDataFound/>
  };

  return (
    <Card sx={{ maxWidth: 600, mx: "auto", mt: 4 }}>
      <CardContent>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight={600}>
              {t("staffDetails")}
          </Typography>
          <Chip
         label={detailsData.is_active ? t("active") : t("inactive")}
  color={detailsData.is_active ? "success" : "error"}

          />
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Details */}
        <Grid container  spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
             {t("firstName")}
            </Typography>
            <Typography fontWeight={500}>{detailsData?.first_name}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              {t("lastName")}
            </Typography>
            <Typography fontWeight={500}>{detailsData?.last_name}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              {t("email")}
            </Typography>
            <Typography fontWeight={500}>{detailsData?.email}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              {t("mobile")}
            </Typography>
            <Typography fontWeight={500}>{detailsData?.mobile}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              {t("dateOfBirth")}
            </Typography>
            <Typography fontWeight={500}>{detailsData?.dob}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              {t("gender")}

            </Typography>
            <Typography fontWeight={500}>
              {detailsData?.gender === "M" ? t("male") : t("female")}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              {t("idType")}
            </Typography>
            <Typography fontWeight={500}>
              {detailsData?.ID_type === "N"
  ? t("nationalId")
  : t("iqama")}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              {t("idNumber")}

            </Typography>
            <Typography fontWeight={500}>{detailsData?.ID_num}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default StaffDetailsCard;
